import { BlockAlign as TiptapBlockExtension } from "@corca/tiptap";

import type { Alignment } from "@corca/tiptap";
import type { Editor } from "@tiptap/react";

type BlockAlignOptions = {
  types: string[];
};

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    alignment: {
      /**
       * Set align attribute
       * @param alignment The alignment
       * @example editor.commands.setAlign('left')
       */
      setAlign: (alignment: string) => ReturnType;
      /**
       * Unset align attribute
       * @example editor.commands.unsetAlign()
       */
      unsetAlign: () => ReturnType;
    };
  }
}

export function getBlockAlignment(editor: Editor): Alignment {
  if (editor.isActive({ alignment: "center" })) {
    return "center";
  }
  if (editor.isActive({ alignment: "right" })) {
    return "right";
  }
  return "left";
}

export const BlockAlign = TiptapBlockExtension.extend<BlockAlignOptions>({
  addCommands() {
    return {
      setAlign:
        (alignment: string) =>
        ({ commands }) => {
          return this.options.types
            .map((type) => commands.updateAttributes(type, { alignment }))
            .every((response) => response);
        },

      unsetAlign:
        () =>
        ({ commands }) => {
          return this.options.types
            .map((type) => commands.resetAttributes(type, "alignment"))
            .every((response) => response);
        },
    };
  },
});
